import { EntityService } from '../../core/services/entity.service';
import { GlobalService } from '../../core/services/global.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Vehicle } from '../model/vehicle';
import { Headers } from '@angular/http';

@Injectable()
export class VehiclesService {

    constructor(private http: GlobalService, private entityService: EntityService) {
    }

    getAll(): Observable<Vehicle[]> {
        const url = `vehicles`;
        return this.http.get(url)
            .map(res => this.entityService.extractData<Vehicle[]>(res))
            .map(data => {
                return data.map(dataItem => this.entityService.copy(dataItem, new Vehicle(dataItem.since, dataItem.until)));
            });
    }

    getByDomainOrInternalNumber(domain: string, internalNumber: number, date: Date, hour: string): Observable<Vehicle> {
        if (domain && domain !== '') {
            return this.getByDomain(domain, date, internalNumber, hour);
        } else {
            return this.getByInternalNumber(internalNumber, date, hour);
        }
    }

    getByDomain(domain: string, date: Date, internalNumber: number, hour: string): Observable<Vehicle> {
        const url = `vehicles/search`;
        return this.http.post(url, { domain, date, internalNumber, hour })
            .map(res => this.entityService.extractData<Vehicle>(res))
            .map(dataItem => this.entityService.copy(dataItem, new Vehicle(dataItem.since, dataItem.until)));
    }

    getByInternalNumber(internalNumber: number, date: Date, hour: string): Observable<Vehicle> {
        const url = `vehicles/getByInternal`;
        return this.http.post(url, { internalNumber, date, hour })
            .map(res => this.entityService.extractData<Vehicle>(res))
            .map(dataItem => this.entityService.copy(dataItem, new Vehicle(dataItem.since, dataItem.until)));
    }

    downloadCertificate(vehicleId: number): Observable<any> {
        const url = `vehicles/getCoverageCertificate/${vehicleId}`;

        const headers = new Headers();
        headers.append('Content-Type', 'application/pdf');
        headers.append('responseType', 'arrayBuffer');

        return this.http.file(url, null, headers)
            .map(x => {
                const blob = new Blob([x.payload.blob()], { type: 'application/pdf' });

                window['saveAs'](blob, 'Certificado de Cobertura.pdf');
            });
    }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/services/vehicles.service.ts